import { t } from '@lingui/macro';
import classnames from 'classnames';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

// Выбор времени суток вынесен на таймлайн внизу карты
// (ClassParkingDayPartRebalancedTimeline). Здесь остаётся только легенда.
const DayPartFilterComponent = () => {
    return (
        <div>
            <div>
                <div className={styles.circlesbox}>
                    <div className={styles.circleClassifiedParking_1}></div>
                    <div className={styles.circleClassifiedParking_2}></div>
                </div>
                <div className={styles.classifiedParkingLegendContainer}>
                    <div className={classnames(styles.legendListItem, styles.legendListItemLeft)}>{t`Средняя`}</div>
                    <div className={classnames(styles.legendListItem, styles.legendListItemRight)}>{t`Топовая`}</div>
                </div>

                <div className={styles.classifiedParkingLegendContainer}>
                    <div className={styles.listItemGeneric}>{t`Баланс`}</div>
                    <div className={styles.listItemGeneric}>{t`Профицит`}</div>
                    <div className={styles.listItemGeneric}>{t`Дефицит`}</div>
                </div>
                <div style={{ padding: '10px' }}>
                    <small>{t`Цвет круга определяет тип парковки`}</small>
                    <br></br>
                    <small>{t`Размер круга определяет класс парковки`}</small>
                </div>
            </div>
            <br/>
            <div style={{ padding: '10px' }}>
                <span className={styles.legendSubtitle}>{t`Классификация парковок по ребалансу за 14 дней в выбранный промежуток времени`}</span>
            </div>
        </div>
    );
};
export const ClassifiedParkingDayPartRebalancedFilter = withDisplayedLayersCheck(
    DayPartFilterComponent,
    `${t`Классифицированные парковки`} (${t`ребаланс, по времени суток`})`
);
